/*********************************************************************************
 1. Dependencies
 *********************************************************************************/

import React               from 'react';
import PropTypes           from 'prop-types';
import { StyledLabel }     from '../../atoms/StyledLabel';
import { StyledTextInput } from '../../atoms/StyledTextInput';


/*********************************************************************************
 2. Component
 *********************************************************************************/

export const TextField = (props) => (
    <div>
        <StyledLabel htmlFor={props.id} hide={props.hideLabel}>{props.label}{props.required && '*'}</StyledLabel>
        <StyledTextInput {...props} />
    </div>
);

TextField.propTypes = {
    label: PropTypes.string,
    hideLabel: PropTypes.bool
};



// WEBPACK FOOTER //
// ./src/components/molecules/TextField/index.js